import React, { useEffect, useState } from 'react'
import { Button } from '../../ui/button';
import Select from "../Common/inputs/SelectDropdown";
import { cashoutOpt } from '../Common/PrimaryplayerTab/ComTab';
import { Payments } from '../../sharedfiles/tooltipMsgs';
import Input from '../Common/inputs/Input';
import { COMMON_CONSTANTS } from '../../sharedfiles/Constants';
import { amountUnitConversion, amountDecimalRegex, amountInputValue } from '../../sharedfiles/helper';
import { setDisableBtn, setPersistedFormData, updatePlayertLimit, updateUserCashoutAvailability, userPaymentLimits } from './LimitsTabSlice';
import { useDispatch, useSelector } from 'react-redux';
import Tooltips from '../Common/Tooltip';
import { getPlayerGeneralDetail } from '../GeneralDetail/GeneralDetailSlice';
import { getBrandCurrenciesList } from '../createbonusnew/createbonusnewslice';
import { FALLBACK_CURRENCIES } from '../createbonusv2/templates';
const LimitsTab = (props) => {
    const updatedCashout = useSelector((state) => state.generaldetail?.playerData)

    const withdrawEnabled = updatedCashout?.userLimit?.withdrawEnabled;
    const depositEnabled = updatedCashout?.userLimit?.depositEnabled;
    const dispatch = useDispatch()
    // Restore the form only for the same player it was saved for
    const savedFormData = useSelector((state) => state.paymentLimitTab.persistedFormData) || {}
    const persistedFormData = savedFormData.userId === localStorage.getItem("userId") ? savedFormData : {}
    const [PaymnetLimits, setPaymnetLimits] = useState(() => persistedFormData.PaymnetLimits ?? "")
    const [limitErr, setLimitErr] = useState(false)
    const [depositMinLimit, setDepositMinLimit] = useState(() => persistedFormData.depositMinLimit ?? "")
    const [depositMaxLimit, setDepositMaxLimit] = useState(() => persistedFormData.depositMaxLimit ?? "")
    const [withdrawMinLimit, setWithdrawMinLimit] = useState(() => persistedFormData.withdrawMinLimit ?? "")
    const [withdrawMaxLimit, setWithdrawMaxLimit] = useState(() => persistedFormData.withdrawMaxLimit ?? "")
    const [depoMinErr, setDepoMinErr] = useState(false)
    const [depoMaxErr, setDepoMaxErr] = useState(false)
    const [withdrawMinErr, setWithdrawMinErr] = useState(false)
    const [withdrawMaxErr, setWithdrawMaxErr] = useState(false)
    const [disable, setDisable] = useState(false)
    const [playerCashout, setPlayerCashout] = useState(() => persistedFormData.playerCashout ?? '')
    const [cashoutErr, setCashoutErr] = useState(false)
    const [updateDeposit, setUpdateDeposit] = useState(() => persistedFormData.updateDeposit ?? depositEnabled);
    const [updateWithdraw, setUpdateWithdraw] = useState(() => persistedFormData.updateWithdraw ?? withdrawEnabled);
    const [disableUpdateButton, setDisableUpdateButton] = useState(false)

    const DepominErrMsg = "Min Deposit Limit is required"
    const DepomaxErrMsg = "Max Deposit Limit is required"
    const WidminErrMsg = "Min Withdrawal Limit is required"
    const WidmaxErrMsg = "Max Withdrawal Limit is required"
    const cashoutErrMsg = "Please choose one of the Option"

    const userId = localStorage.getItem("userId")
    const disableBtn = useSelector((state) => state.paymentLimitTab.disableBtn)
    const updatedLimits = useSelector((state) => state.paymentLimitTab.updatedLimits)
    const viewOnlyuser = useSelector((state) => state.dashboard.viewOnlyuser)
    // const updatedCashout = useSelector((state) => state.generaldetail?.playerData)
    const casoutPermission = useSelector((state) => state.dashboard?.playerCashoutPermission)
    // Same currency source as the Create Bonus page
    const brandCurrenciesList = useSelector((state) => state.bonus.brandCurrenciesList)
    const currencyOptions = brandCurrenciesList?.length > 0 ? brandCurrenciesList : FALLBACK_CURRENCIES
    const [limitCurrency, setLimitCurrency] = useState(() => persistedFormData.limitCurrency ?? "")

    // Stored limit for a configType in the selected currency: empty until a currency is selected,
    // the amount when a config matches it, otherwise 0. A config without currencyCode belongs to the player's currency.
    const storedLimitAmount = (configType, key, currency) => {
        if (!currency) return ""
        const playerCurrency = updatedCashout?.userOtherInfo?.currencyCode
        const config = Array.isArray(updatedLimits) && updatedLimits.find(c =>
            c.configType === configType && (c.currencyCode || playerCurrency)?.toUpperCase() === currency.toUpperCase())
        return config ? amountInputValue(config[key], currency) : 0
    }

    const options = [
        { label: "Enable", value: true },
        { label: "Disable", value: false }
    ]

    const handleChange = (e) => {
        const { value } = e.target

        if (value === "") {
            setLimitErr(true)
        } else {
            setLimitErr(false)
            setPaymnetLimits(value)
        }
        setPaymnetLimits(value);
    }

    // Amounts are currency-specific, so reload the stored limits for the newly selected currency
    const handleCurrencyChange = (e) => {
        const { value } = e.target
        if (value === limitCurrency) return
        setLimitCurrency(value)
        setDepositMinLimit(storedLimitAmount('DEPOSIT', 'minLimit', value))
        setDepositMaxLimit(storedLimitAmount('DEPOSIT', 'maxLimit', value))
        setWithdrawMinLimit(storedLimitAmount('WITHDRAW', 'minLimit', value))
        setWithdrawMaxLimit(storedLimitAmount('WITHDRAW', 'maxLimit', value))
        setDepoMinErr(false)
        setDepoMaxErr(false)
        setWithdrawMinErr(false)
        setWithdrawMaxErr(false)
    }

    const cashoutUpdate = (e) => {
        const value = e.target.value
        setPlayerCashout(value)
        if (value === '') {
            setCashoutErr(true)
        } else {
            setCashoutErr(false)
        }
    }

    const handleInput = (e) => {
        const { name, value } = e.target
        switch (name) {
            case "depositMinLimit":
                setDepositMinLimit(value);
                setDepoMinErr(false)
                break;
            case "depositMaxLimit":
                setDepositMaxLimit(value);
                setDepoMaxErr(false)
                break;
            case "withdrawMinLimit":
                setWithdrawMinLimit(value);
                setWithdrawMinErr(false)
                break;
            case "withdrawMaxLimit":
                setWithdrawMaxLimit(value);
                setWithdrawMaxErr(false)
                break;
            default:
            break;
        }
    }

    const onSubmit = () => {
        if (PaymnetLimits === "DEPOSIT LIMITS") {
            if (depositMinLimit === "" || depositMaxLimit !== "") {
                setDepoMinErr(true)
                setDepoMaxErr(false)
            } else if (depositMinLimit !== "" && depositMaxLimit === "") {
                setDepoMinErr(false)
                setDepoMaxErr(true)
            }
        }
        if (PaymnetLimits === "WITHDRAW LIMITS") {
            if (withdrawMinLimit === "" || withdrawMaxLimit !== "") {
                setWithdrawMinErr(true)
                setWithdrawMaxErr(false)
            } else if (withdrawMinLimit !== "" && withdrawMaxLimit === "") {
                setWithdrawMinErr(false)
                setWithdrawMaxErr(true)
            }
        }

        if (PaymnetLimits === "DEPOSIT LIMITS" && depositMinLimit !== "" && depositMaxLimit !== "") {
            const data = {
                configType: "DEPOSIT",
                maxLimit: amountUnitConversion(depositMaxLimit, limitCurrency),
                minLimit: amountUnitConversion(depositMinLimit, limitCurrency),
                userId: userId,
                ...(limitCurrency && { currencyCode: limitCurrency })
            }
            dispatch(userPaymentLimits(data))
            setDisable(true)
            setDepoMinErr(false)
        }

        if (PaymnetLimits === "WITHDRAW LIMITS" && withdrawMinLimit !== "" && withdrawMaxLimit !== "") {
            const data = {
                configType: "WITHDRAW",
                maxLimit: amountUnitConversion(withdrawMaxLimit, limitCurrency),
                minLimit: amountUnitConversion(withdrawMinLimit, limitCurrency),
                userId: userId,
                ...(limitCurrency && { currencyCode: limitCurrency })
            }
            dispatch(userPaymentLimits(data))
            setDisable(true)
            setWithdrawMinErr(false)
        }

        if (PaymnetLimits === "PLAYERCASHOUT" && !cashoutErr) {
            const userId = localStorage.getItem("userId");
            const payloadVal = playerCashout === "ENABLE" ? true : false
            const data = {
                isCashoutEnabled: payloadVal,
                userId: userId
            }
            dispatch(updateUserCashoutAvailability(data))
            setDisable(true)
        }
        if (PaymnetLimits === "DEPOSIT") {
            let booleanPayload = updateDeposit

            const payload = {
                depositEnabled: booleanPayload
            }
            const userId = localStorage.getItem("userId");
            setDisableUpdateButton(true)
            dispatch(updatePlayertLimit(userId, payload));
            setTimeout(() => {
                setDisableUpdateButton(false)
            }, 3000);
        }
        if (PaymnetLimits === "WITHDRAW") {
            let booleanPayload = updateWithdraw
            const payload = {
                withdrawEnabled: booleanPayload
            }
            const userId = localStorage.getItem("userId");
            setDisableUpdateButton(true)
            dispatch(updatePlayertLimit(userId, payload));
            setTimeout(() => {
                setDisableUpdateButton(false)
            }, 3000);
        }
    }
    useEffect(() => {
        var btnTimer;
        if (disableBtn) {
            btnTimer = setTimeout(() => {
                dispatch(setDisableBtn(false))
                setDisable(false)
            }, 2500)
        };
        return () => clearTimeout(btnTimer);
    }, [disableBtn]);

    useEffect(() => {
        // playerData defaults to [] and becomes an object once loaded - if it's
        // already loaded (e.g. switching back to this tab), refresh it silently
        // instead of wiping it and showing a blank/loading state.
        const dataExist = updatedCashout && !Array.isArray(updatedCashout) && Object.keys(updatedCashout).length > 0;
        dispatch(getPlayerGeneralDetail({ user_id: userId, silent: dataExist }));
        if (!brandCurrenciesList?.length) {
            dispatch(getBrandCurrenciesList());
        }
        // setUpdateDeposit(depositEnabled)
        // setUpdateWithdraw(withdrawEnabled)
    }, [])

    useEffect(() => {
        // Limit amounts stay empty until a currency is selected (see handleCurrencyChange),
        // and a restored form keeps its own values instead of the page-load ones.
        if (persistedFormData.playerCashout === undefined) {
            const cashoutValue = updatedCashout.userOtherInfo?.isCashOutEnabled
            const pageLoadVal = cashoutValue === true ? "ENABLE" : "DISABLE"
            setPlayerCashout(pageLoadVal)
        }
    }, [])

    // Mirrors the persistable form fields into redux on every change, so they
    // survive this page unmounting/remounting on tab switch.
    useEffect(() => {
        dispatch(setPersistedFormData({ userId, PaymnetLimits, limitCurrency, depositMinLimit, depositMaxLimit, withdrawMinLimit, withdrawMaxLimit, playerCashout, updateDeposit, updateWithdraw }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [PaymnetLimits, limitCurrency, depositMinLimit, depositMaxLimit, withdrawMinLimit, withdrawMaxLimit, playerCashout, updateDeposit, updateWithdraw]);
    const handleDepositAction = (e) => {
        let { value } = e.target;
        setUpdateDeposit(value)
    };
    const handleWithdrawAction = (e) => {
        let { value } = e.target;
        setUpdateWithdraw(value)
    };

    return (
        <div className="flex flex-col gap-4">
            <div>
                <h2 className='text-lg font-semibold text-foreground'>Payment Limits</h2>
                <p className='text-sm text-muted-foreground mt-1'>Manage player deposit and withdrawal limits</p>
            </div>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4'>
                <div className='space-y-2'>
                    <Select
                        title={"Payment Limits"}
                        name={"PaymnetLimits"}
                        ids={"paymentlimitTab"}
                        value={PaymnetLimits}
                        setValue={(e) => handleChange(e)}
                        options={[
                            { label: COMMON_CONSTANTS.ddlOpt_select, value: '' },
                            { label: "Deposit Limits", value: "DEPOSIT LIMITS" },
                            { label: "Withdraw Limits", value: "WITHDRAW LIMITS" },
                            { label: "Withdraw", value: "WITHDRAW" },
                            { label: "Deposit", value: "DEPOSIT" },
                            ...(casoutPermission ? [{ label: "Player Cashout", value: "PLAYERCASHOUT" }] : [])
                        ]}
                        errorMsg={limitErr && "Please select your Payment Limits"}
                        info={Payments.Payment_limits}
                    />
                </div>
                {(PaymnetLimits === "DEPOSIT LIMITS" || PaymnetLimits === "WITHDRAW LIMITS") && (
                    <div className='space-y-2'>
                        <Select
                            title={"Currency"}
                            name={"limitCurrency"}
                            ids={"limitCurrency"}
                            value={limitCurrency}
                            setValue={(e) => handleCurrencyChange(e)}
                            options={[
                                { label: COMMON_CONSTANTS.ddlOpt_select, value: '' },
                                ...currencyOptions
                            ]}
                            info={"Select the currency for the limits"}
                        />
                    </div>
                )}
                {PaymnetLimits === "DEPOSIT LIMITS" && (
                    <div className='space-y-2'>
                        <Input
                            title={"Min Deposit Limit"}
                            name={"depositMinLimit"}
                            ids={"depositMinLimit"}
                            value={depositMinLimit}
                            placeholder={'Min Deposit Limit'}
                            setValue={(e) => handleInput(e)}
                            errorMsg={depoMinErr && DepominErrMsg}
                            info={Payments.DepoMinLimit}
                            show={true}
                            regex={amountDecimalRegex(limitCurrency)}
                        />
                    </div>
                )}
                {PaymnetLimits === "DEPOSIT LIMITS" && (
                    <div className='space-y-2'>
                        <Input
                            title={"Max Deposit Limit"}
                            name={"depositMaxLimit"}
                            ids={"depositMaxLimit"}
                            value={depositMaxLimit}
                            placeholder={"Max Deposit Limit"}
                            setValue={(e) => handleInput(e)}
                            errorMsg={depoMaxErr && DepomaxErrMsg}
                            info={Payments.DepoMaxLimit}
                            show={true}
                            regex={amountDecimalRegex(limitCurrency)}
                        />
                    </div>
                )}
                {PaymnetLimits === "WITHDRAW LIMITS" && (
                    <div className='space-y-2'>
                        <Input
                            title={"Min Withdrawal Limit"}
                            name={"withdrawMinLimit"}
                            ids={"withdrawMinLimit"}
                            value={withdrawMinLimit}
                            placeholder={"Min Withdrawal Limit"}
                            setValue={(e) => handleInput(e)}
                            errorMsg={withdrawMinErr && WidminErrMsg}
                            info={Payments.WithdrawMinLimit}
                            show={true}
                            regex={amountDecimalRegex(limitCurrency)}
                        />
                    </div>
                )}
                {PaymnetLimits === "WITHDRAW LIMITS" && (
                    <div className='space-y-2'>
                        <Input
                            title={"Max Withdrawal Limit"}
                            name={"withdrawMaxLimit"}
                            ids={"withdrawMaxLimit"}
                            value={withdrawMaxLimit}
                            placeholder={"Max Withdrawal Limit"}
                            setValue={(e) => handleInput(e)}
                            errorMsg={withdrawMaxErr && WidmaxErrMsg}
                            info={Payments.WithdrawMaxLimit}
                            show={true}
                            regex={amountDecimalRegex(limitCurrency)}
                        />
                    </div>
                )}
                {PaymnetLimits === "PLAYERCASHOUT" && (
                    <div className='space-y-2'>
                        <Select
                            title={"Actions"}
                            name={"playerCashout"}
                            ids={"playerCashout"}
                            value={playerCashout}
                            setValue={(e) => cashoutUpdate(e)}
                            options={cashoutOpt}
                            errorMsg={cashoutErr && cashoutErrMsg}
                            info={Payments.playerCasout}
                        />
                    </div>
                )}
                {PaymnetLimits === "DEPOSIT" && (
                    <div className='space-y-2'>
                        <Select
                            title={"Actions"}
                            name={"Actions"}
                            ids={"Actions"}
                            value={updateDeposit}
                            setValue={(val) => handleDepositAction(val)}
                            options={options}
                            info={"Showing Actions"}
                        />
                    </div>
                )}
                {PaymnetLimits === "WITHDRAW" && (
                    <div className='space-y-2'>
                        <Select
                            title={"Actions"}
                            name={"Actions"}
                            ids={"Actions"}
                            value={updateWithdraw}
                            setValue={(val) => handleWithdrawAction(val)}
                            options={options}
                            info={"Showing Actions"}
                        />
                    </div>
                )}
            </div>
            {PaymnetLimits !== "" ?
                <div className='flex flex-wrap -mx-3'>
                    <div className='w-full px-3'>
                        <div className="flex flex-wrap gap-3">
                            <Button
                                onClick={(e) => onSubmit(e)}
                                type={"button"}
                                id={"updateLimit"}
                                variant="default"
                                disabled={disable || disableUpdateButton || viewOnlyuser}
                            >
                                {COMMON_CONSTANTS.update_Btn}
                            </Button>
                        </div>
                    </div>
                </div>
            : ""}
        </div>
    )
}

export default LimitsTab